import { IconProps } from "./IconProps";

const CheckWithCircleIcon = ({ size = 24, color, testID }: IconProps) => (
  <svg
    width={size}
    height={size}
    color={color}
    data-testid={testID}
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99967 19.1667C15.0623 19.1667 19.1663 15.0626 19.1663 9.99999C19.1663 4.93738 15.0623 0.833328 9.99967 0.833328C4.93706 0.833328 0.833008 4.93738 0.833008 9.99999C0.833008 15.0626 4.93706 19.1667 9.99967 19.1667ZM13.979 6.83625C14.0854 6.72675 14.2302 6.66297 14.3828 6.65842C14.5011 6.65493 14.6177 6.68727 14.7174 6.75119C14.817 6.81512 14.895 6.90765 14.9411 7.01666C14.9872 7.12567 14.9994 7.24608 14.9759 7.3621C14.9524 7.47812 14.8945 7.58434 14.8096 7.66685L8.34832 14.1281C8.23816 14.2382 8.08877 14.3001 7.93302 14.3001C7.77726 14.3001 7.62788 14.2382 7.51772 14.1281L5.16817 11.7786C5.11179 11.7244 5.06678 11.6596 5.03578 11.5879C5.00477 11.5161 4.98839 11.4389 4.9876 11.3608C4.9868 11.2826 5.00161 11.2051 5.03115 11.1328C5.06069 11.0604 5.10437 10.9947 5.15963 10.9394C5.21489 10.8842 5.28062 10.8405 5.35297 10.8109C5.42533 10.7814 5.50285 10.7666 5.58099 10.7674C5.65914 10.7682 5.73634 10.7846 5.80808 10.8156C5.87981 10.8466 5.94464 10.8916 5.99877 10.948L7.93302 12.8822L13.979 6.83625Z"
      fill="#4FBD19"
    />
  </svg>
);

export { CheckWithCircleIcon };
